export default "/build/static/fonts/Whitney-Medium_Web.woff";